import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse } from 'seagull';
import styles from './TriageCollapseWrapper.module.scss';
export const TriageCollapseWrapper = (param)=>{
    let { open, children, testId } = param;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": testId,
        "data-panel-open": open,
        children: /*#__PURE__*/ _jsx(Collapse, {
            in: open,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.collapseWrapper,
                children: children
            })
        })
    });
};
